import React from 'react';
import lockIcon from './assets/locked.png';
import unlockIcon from './assets/unlock.png';
import unlockWhite from './assets/unlock-white.png';

const LockButton = ({ onClick, isLocked, isDoc1 }) => {

  const isWhiteUnlock = !isLocked && isDoc1;

  const iconSrc = isLocked
    ? lockIcon
    : isWhiteUnlock
      ? unlockWhite
      : unlockIcon;

  return (
    <button
      onClick={onClick}
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer'
      }}
      type="button"
      title={isLocked ? "This line item is locked with this match and can not be used in any other match." : "This line item is unlocked and may be used in multiple matches."}
      aria-label={isLocked ? 'Unlock' : 'Lock'}
    >
      <img
        src={iconSrc}
        alt={isLocked ? 'Locked' : 'Unlocked'}
        style={{
          width: isWhiteUnlock ? '24px' : '16px',
          height: 'auto',
          display: 'block'
        }}
      />
    </button>
  );
};

export default LockButton;
